export default class RoundType {
  constructor (data) {
    this.id = data.id
    this.name = data.name
  }
}
